<div class="dp-map-wrap" *ngIf="!loadProjects">
    <app-loading-indicator class="no-bg" *ngIf="loadProjectMarkers">
        {{ 'dashboard.project-map-loading' | translate }}
    </app-loading-indicator>
    <div
        class="dp-map-container"
        leaflet
        [leafletOptions]="mapOptions"
        [leafletCenter]="mapCenter"
        [leafletZoom]="mapZoom"
        (leafletMapReady)="onLeafletMapReady($event)"
        [leafletMarkerCluster]="markerClusterData"
        [leafletMarkerClusterOptions]="markerClusterOptions"
    ></div>
</div>

<app-loading-indicator class="no-bg" *ngIf="loadProjects">
    {{ 'dashboard.project-map-loading' | translate }}
</app-loading-indicator>
